import { tileType } from "../gameLogic/rules";

export function getCurrentPlayerSocketId (turn, teams) {
  if (teams[turn.team].players[turn.players[turn.team]] != undefined) {
    return teams[turn.team].players[turn.players[turn.team]].id
  } else {
    return "no_player_found"
  }
}

export function bothTeamsHavePlayers(teams) {
  if (teams[0].players.length > 0 && teams[1].players.length > 0) {
    return true
  } else {
    return false;
  }
}

export function movesIsEmpty (moves) {
  for (const move in moves) {
    if (parseInt(move) != 0 && moves[move] > 0) {
      return false;
    }
  }
  return true;
}

export function clearMoves(moves) {
  for (const move in moves) {
    moves[move] = 0
  }
  return moves;
}

export function hasValidMove (moves) {
  let flag = false;
  for (let move in moves) {
    if (parseInt(move) != 0 && moves[move] > 0) {
      flag = true;
      break;
    }
  }
  return flag
}

export function isMyTurn (turn, teams, socketId) {
  if (getCurrentPlayerSocketId(turn, teams) === socketId) {
    return true
  } else {
    return false
  }
}

export function hasValidMoveHome(pieces, moves, backdoLaunch) {
  // 0 is not a valid move
  let pieceOnBoard = false
  for (const piece of pieces) {
    if (tileType(piece.tile) === 'onBoard') {
      pieceOnBoard = true
    }
  }

  if (!pieceOnBoard) {
    for (const move in moves) {
      if (!backdoLaunch && parseInt(move) === -1) {
        continue
      } else if (parseInt(move) !== 0 && moves[move] > 0) {
        return true;
      }
    }
    return false;
  } else {
    for (const move in moves) {
      if (parseInt(move) !== 0 && parseInt(move) !== -1 && moves[move] > 0) {
        return true;
      }
    }
    return false;
  }
}

export function clientHasTurn(clientSocketId, teams, newTeam, newPlayer) {
  // Check if a player is at the index
  // He/she could have dropped
  if (teams[newTeam].players[newPlayer] &&
  teams[newTeam].players[newPlayer].socketId === clientSocketId) {
    return true;
  } else {
    return false;
  }
}

export function getPlayerBySocketId(teams, socketId) {
  for (let i = 0; i < teams.length; i++) {
    for (let j = 0; j < teams[i].players.length; j++) {
      if (teams[i].players[j].socketId === socketId) {
        return JSON.parse(JSON.stringify(teams[i].players[j]))
      }
    }
  }
  return {} // not found
}

export function makeId(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function getRandomNumber(min, max) {
  let randomNumber = (max - min) * Math.random() + min
  return randomNumber;
}

export function roundNum(num, place) {
  return Math.round(num * Math.pow(10, place)) / Math.pow(10, place)
}

export function generateRandomNumberInRange(num, plusMinus) {
  return num + Math.random() * plusMinus * (Math.random() > 0.5 ? 1 : -1);
};

export function formatName(name, maxLength = 10) {
  if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...'
  } else {
      return name
  }
}

export function getNameFont(name, fallbackFont = '/fonts/Luckiest Guy_Regular.json') {
  const hasKoreanJamo = Array.from(name ?? '').some((character) => {
    const codePoint = character.codePointAt(0)
    return (codePoint >= 0x1100 && codePoint <= 0x11ff) ||
      (codePoint >= 0x3130 && codePoint <= 0x318f)
  })
  if (hasKoreanJamo) {
    return '/fonts/Maplestory_Bold.json'
  }
  if (/[\uac00-\ud7a3]/.test(name ?? '')) {
    return '/fonts/Maplestory_Bold.json'
  }
  if (containsChineseCharacters(name)) {
    return '/fonts/Xiao Xiangjiao font_Regular.json'
  }
  return fallbackFont
}

export function getLanguageFont(language) {
  if (language === 'korean') {
    return '/fonts/Maplestory_Bold.json'
  }
  if (language === 'chinese') {
    return '/fonts/Xiao Xiangjiao font_Regular.json'
  }
  return '/fonts/Luckiest Guy_Regular.json'
}

export function containsChineseCharacters(name) {
  return /[\u3400-\u9fff\uf900-\ufaff]/u.test(name ?? '')
}

export function pieceSelected(selection, pieceId, team) {
  if (selection) {
    for (const piece of selection.pieces) {
      if (piece.id === pieceId && piece.team === team) {
        return true
      }
    }
    return false
  } else {
    return false
  }
}

export function isBackdoMovesWithoutPieces(moves, pieces) {
  if (moves['-1'] === 0) {
    return false;
  }

  for (let i = 0; i < 4; i++) {
    if (tileType(pieces[i].tile) === 'onBoard') {
      return false
    }
  }

  for (const move in moves) {
    if (parseInt(move) !== 0 && parseInt(move) !== -1 && moves[move] > 0) {
      return false;
    }
  }
  
  return true
}

export function getScore(team) {
  let score = 0
  for (const token of team.pieces) {
    if (token.tile === 29) {
      score++
    }
  }
  return score
}

export function copyURLToClipboard() {
  const url = window.location.href;

  if (navigator.clipboard && navigator.clipboard.writeText) {
    // Modern browsers with Clipboard API support
    navigator.clipboard.writeText(url)
      .then(() => {
      })
      .catch(err => {
        console.error("Failed to copy URL: ", err);
      });
  } else {
    // Fallback for older browsers
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  }
}

export function roomHasAI(room) {
  for (let i = 0; i < room.teams.length; i++) {
    for (const player of room.teams[i].players) {
      if (player.type === 'ai') {
        return true
      }
    }
  }
  return false
}

// precondition: argument is an array
export function pickRandomElement(array) {
  const length = array.length
  const randomNum = Math.random()
  const randomIndex = Math.floor(length * randomNum)
  return array[randomIndex]
}

export function caughtCheck(gamePhase, tile) {
    return gamePhase === 'game' && tile === -1
}

export function startCheck(tile, lastPath) {
    const condition0 = (tile === 0 && lastPath[0] === 1)
    const condition1 = (tile <= 5 && lastPath[0] === 0)
    return (condition0 || condition1)
}

const STAR_JUMP_TIME = 820
export function calculateCatchDelay(catchPath) {
    if (catchPath[0] === 1 && catchPath[1] === 0) {
        return (catchPath.length-1) * STAR_JUMP_TIME
    } if (catchPath[0] === 0 && (catchPath[1] !== 19 && catchPath[1] !== 28)) {
        return (catchPath.length-1) * STAR_JUMP_TIME
    } else {
        return (catchPath.length-2) * STAR_JUMP_TIME
    }
}